import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Divider, InputRadio, Typography } from 'shared/ui'
import { type PhoneCheckrStore } from 'pages/settings/ui/PhoneCheckr'
import styles from './styles.module.scss'

type IPhoneCheckSecondModalContentProps = {
  store: PhoneCheckrStore
}

export const PhoneCheckSecondModalContent: FC<IPhoneCheckSecondModalContentProps> = observer(
  ({ store }) => {
    const { lookupOption, setLookupOption } = store
    return (
      <div className={styles.phoneCheckrModalContent}>
        <div className={styles.phoneCheckrModalTitle}>
          <Typography ariaLabel='phone_check_first_modal_title' variant='heading-lg'>
            PhoneCheckr
          </Typography>
          <Typography
            ariaLabel='phone_check_first_modal_description'
            variant='body-rg-regular'
            color='var(--content-primary-primary)'
          >
            $0.01 / lookup
          </Typography>
        </div>
        <div className={styles.phoneCheckrModalInputs}>
          <InputRadio
            variant={'default'}
            checked={lookupOption === 'all'}
            radioSize='small'
            onChecked={() => setLookupOption('all')}
            label='Look up all existing contacts'
            className={styles.phoneCheckrModalInput}
          />
          <Divider />
          <InputRadio
            radioSize='small'
            variant={'default'}
            checked={lookupOption === 'new'}
            onChecked={() => setLookupOption('new')}
            className={styles.phoneCheckrModalInput}
            label='Look up new contacts only'
          />
        </div>

        <Typography
          ariaLabel='phone_check_second_modal_description'
          variant='text-input-label-small'
          color='var(--content-primary-tertiary)'
          tag='div'
          className={styles.phoneCheckrModalDescription}
        >
          PhoneCheckr will be billed to your account separately. It is not included in your
          subscription fee.
        </Typography>
      </div>
    )
  }
)
